import editForm from 'formiojs/components/textarea/TextArea.form'

export default function (...extend) {
    return editForm([
        {
            key: 'display',
            components: [
                {
                    key: 'editor',
                    ignore: true,
                },
                {
                    key: 'inputMask',
                    ignore: true,
                },
                {
                    key: 'allowMultipleMasks',
                    ignore: true,
                },
                {
                    key: 'showWordCount',
                    ignore: true
                },
                {
                    key: 'showCharCount',
                    ignore: true
                },
                {
                    key: 'spellcheck',
                    ignore: true
                },
                {
                    key: 'prefix',
                    ignore: true
                },
                {
                    key: 'suffix',
                    ignore: true
                },
                {
                    key: 'autocomplete',
                    ignore: true
                },
                {
                    key: 'widget.type',
                    ignore: true
                },
                {
                    key: 'widget',
                    ignore: true
                },
            ]
        }
    ], ...extend);
}
